// src/components/OnboardingCompletion.js
import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const OnboardingCompletion = () => {
  return (
    <div className="text-center">
      <FaCheckCircle className="mx-auto text-green-500 text-6xl" />
      <h2 className="mt-4 text-2xl font-bold text-gray-800">Onboarding Complete!</h2>
      <p className="mt-2 text-gray-600">
        Thank you for providing your information. You're all set!
      </p>
      <Link
        to="/dashboard"
        className="mt-6 inline-block px-6 py-3 text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-200"
      >
        Go to Dashboard
      </Link>
    </div>
  );
};

export default OnboardingCompletion;
